import { ReportChart } from '@/components/relatorios/ReportChart'
import { ReportKpiCard } from '@/components/relatorios/ReportKpiCard'
import { ReportShell } from '@/components/relatorios/ReportShell'
import { ReportTable } from '@/components/relatorios/ReportTable'
import { exportCsv, formatDuration, formatPercent } from '@/components/relatorios/reportUtils'
import { useResponseTimeReport } from '@/hooks/reports/reportHooks'
import { useReportDateRange } from '@/hooks/reports/useReportDateRange'

export default function TempoRespostaReport() {
  const [range, setRange] = useReportDateRange()
  const report = useResponseTimeReport(range)
  const total = report.data.reduce((sum, row) => sum + row.responses, 0)
  const weightedAverage = total
    ? report.data.reduce((sum, row) => sum + row.averageSeconds * row.responses, 0) / total
    : 0

  return (
    <ReportShell
      title="Tempo médio de resposta"
      description="Primeira resposta humana por turno; IA e follow-ups são ignorados."
      {...range}
      onRangeChange={setRange}
      loading={report.loading}
      error={report.error}
      empty={total === 0}
      onRetry={report.refetch}
      onExport={() => exportCsv('tempo-resposta', report.data, [
        { label: 'Vendedor', value: (row) => row.seller },
        { label: 'Respostas', value: (row) => row.responses },
        { label: 'Média (s)', value: (row) => Math.round(row.averageSeconds) },
        { label: 'Mediana (s)', value: (row) => Math.round(row.medianSeconds) },
        { label: 'Mínimo (s)', value: (row) => Math.round(row.minSeconds) },
        { label: 'Máximo (s)', value: (row) => Math.round(row.maxSeconds) },
        { label: 'Abaixo de 5 min (%)', value: (row) => row.underFiveMinutesPercentage.toFixed(1).replace('.', ',') },
      ])}
    >
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <ReportKpiCard label="Respostas analisadas" value={total} />
        <ReportKpiCard label="Média geral" value={formatDuration(weightedAverage)} />
      </div>
      <ReportChart
        type="bar"
        data={report.data.map((row) => ({ ...row, averageMinutes: row.averageSeconds / 60 }))}
        xKey="seller"
        series={[{ key: 'averageMinutes', label: 'Média (min)', color: 'var(--primary)' }]}
      />
      <ReportTable
        rows={report.data.filter((row) => row.responses > 0)}
        rowKey={(row) => row.sellerId}
        columns={[
          { key: 'seller', label: 'Vendedor', render: (row) => row.seller },
          { key: 'responses', label: 'Respostas', align: 'right', render: (row) => row.responses },
          { key: 'average', label: 'Média', align: 'right', render: (row) => formatDuration(row.averageSeconds) },
          { key: 'median', label: 'Mediana', align: 'right', render: (row) => formatDuration(row.medianSeconds) },
          { key: 'min', label: 'Mín.', align: 'right', render: (row) => formatDuration(row.minSeconds) },
          { key: 'max', label: 'Máx.', align: 'right', render: (row) => formatDuration(row.maxSeconds) },
          { key: 'under5', label: '< 5 min', align: 'right', render: (row) => formatPercent(row.underFiveMinutesPercentage) },
        ]}
      />
    </ReportShell>
  )
}
